import React, { Component } from 'react'
import moment from 'moment';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL, decodeText } from "../../libs/utils/Const";
import { development } from "../../libs/utils/Const";
import config from "../../config";
import { element } from 'prop-types';

class DetailsCutInventory extends Component {
    DocumentType = (ObjType) => {

        let name = "";
        switch (ObjType) {
            case 10000071:
                name = 'Contabilización de inventario';
                break;
            case 132:
                name = 'Factura de corrección';
                break;
            case 13:
                name = 'Factura de deudores';
                break;
            case 14:
                name = 'Nota de crédito de deudores';
                break;
            case 162:
                name = 'Revaluación de inventario';
                break;
            case 15:
                name = 'Entregas';
                break;
            case 16:
                name = 'Devoluciones';
                break;
            case 18:
                name = 'Factura de acreedores';
                break;
            case 19:
                name = 'Nota de crédito de acreedores';
                break;
            case 20:
                name = 'Entrada de mercancías';
                break;
            case 21:
                name = 'Devolución de mercancías';
                break;
            case 310000001:
                name = 'Cantidad inicial';
                break;
            case 58:
                name = 'Actualización de existencias';
                break;
            case 59:
                name = 'Entrada de mercancías';
                break;
            case 60:
                name = 'Salida de mercancías';
                break;
            case 67:
                name = 'Transferencia de inventario';
                break;
            default:
                break;
        }

        return name;
    };

    TypeEnvase = (type) => {

        let name = "";
        switch (type) {
            case '0':
                name = 'Producto terminado';
                break;
            case '1':
                name = 'Cilindro';
                break;
            case '2':
                name = 'Cesion en uso';
                break;
            case '3':
                name = 'Gasto administrativo';
                break;
            default:
                break;
        }

        return name;
    };

    render() {
        const { Header, InStock, InStockCesion, Lines, Sales, Orders, Invoices, MyDate, idSessionSelected, reprint, user, time } = this.props
        const today = moment(new Date()).format('YYYY-MM-DD');
        const _user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        return (
            <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginBottom: "100px" }}>
                <div className="row">
                    <div className="col-3">
                        <img src={development ? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                        <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /><strong></strong></p>
                    </div>
                    <div className="col-6 text-center">
                        <h5><strong>DETALLE CORTE DE INVENTARIO DE</strong></h5>
                        <h5><strong>ALMACÉN {decodeText(Header.WhsName) || ''}</strong></h5>
                    </div>
                    <div className="col-3">
                        <p>Sucursal: {_user?.Branch.CodeBranchOffice ?? ''}<br />
                            <label>Folio: {idSessionSelected + "-" + today.replace(/-/g, "") + "D"}</label></p>
                        {/* <p>FECHA DE CIERRE: <br />{moment(MyDate).format('YYYY-MM-DD')}</p> */}
                    </div>
                </div>
                <div className='row mt-4' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2">Información del corte</th>
                            </tr>
                        </thead>
                    </table>
                    <table>
                        <thead style={{ border: "solid 1px" }}>
                            <tr>
                                <th className="text-left">Nombre del chofer</th>
                                <th className="text-left">Placa</th>
                                <th className="text-left">Inicio de ruta</th>
                                <th className="text-left">Fin de ruta</th>
                                {/* <th className="text-right">Ingresos</th> */}
                                {/* <th className="text-right">Egresos</th> */}
                                {/* <th className="text-right">Existencia</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ fontSize: '12px' }}>
                                <td className="text-left">{Header.U_NAME || ''}</td>
                                <td className="text-left">{Header.PlacaVM || 'Sin placa'}</td>
                                <td className="text-left">{Header.docDate ? moment(Header.docDate).utc().format('MM/DD/YYYY') : 'Sin fecha'}</td>
                                <td className="text-left">{Header.twoFAValidatedAt ? moment(Header.twoFAValidatedAt).utc().format('MM/DD/YYYY') : 'Sin fecha'}</td>
                                {/* <td className="text-right">{Number(Header.InQty).toFixed(2)}</td> */}
                                {/* <td className="text-right">{Number(Header.OutQty).toFixed(2)}</td> */}
                                {/* <td className="text-right">{Number(Header.Exist).toFixed(2)}</td> */}
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* LISTADO DE ARTICULOS EN MI UBICACIÓN */}
                <div className='row mt-4' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2">ARTICULOS EN MI UBICACIÓN</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div className='row mt-2' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ border: "solid 1px" }}>
                            <tr>
                                <th className="text-left">Articulo</th>
                                <th className="text-left">Nombre del artículo</th>
                                <th className="text-left">Tipo de envase</th>
                                <th className="text-left">En stock</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!!InStock && InStock.map((stock, index) => {

                                return (
                                    <tr style={{ fontSize: '12px' }}>
                                        <td className="text-left">{stock.ItemCode}</td>
                                        <td className="text-left">{stock.ItemName}</td>
                                        <td className="text-left">{this.TypeEnvase(stock.U_FMB_IS_CILINDRO)}</td>
                                        <td className="text-left">{Number(stock.OnHandQty || 0).toFixed(2)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                {/* CILINDROS PRESTADOS */}
                <div className='row mt-4' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2">CILINDROS PRESTADOS</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div className='row mt-2' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ border: "solid 1px" }}>
                            <tr>
                                <th className="text-left">Código cliente</th>
                                <th className="text-left">Nombre cliente</th>
                                <th className="text-left">Articulo</th>
                                <th className="text-left">Nombre del artículo</th>
                                <th className="text-left">Tipo de envase</th>
                                <th className="text-left">Cantidad</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!!InStockCesion && InStockCesion.map((stock, index) => {

                                return (
                                    <tr style={{ fontSize: '12px' }}>
                                        <td className="text-left">{stock.CardCode || ''}</td>
                                        <td className="text-left">{stock.CardName || ''}</td>
                                        <td className="text-left">{stock.ItemCode}</td>
                                        <td className="text-left">{stock.Dscription || ''}</td>
                                        <td className="text-left">{this.TypeEnvase(stock.U_FMB_IS_CILINDRO)}</td>
                                        <td className="text-left">{Number(stock.Quantity || 0).toFixed(2)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                {/* ARTICULOS */}
                <div className='row mt-4' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2">INFORME ARTICULOS</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div className='row mt-2' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ border: "solid 1px" }}>
                            <tr>
                                <th className="text-left">Tipo</th>
                                <th className="text-left">Folio</th>
                                <th className="text-center">Artículo</th>
                                <th className="text-left">Fecha</th>
                                <th className="text-right">Ingresos</th>
                                <th className="text-right">Egresos</th>
                                {/* <th className="text-right">Existencia</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {!!Lines && Lines.map((kardex, index) => {

                                return (
                                    <tr style={{ fontSize: '12px' }}>
                                        <td className="text-left">{this.DocumentType(kardex.TransType)}</td>
                                        <td className="text-left">{kardex.NumAtCard && kardex.NumAtCard !== '' ? kardex.NumAtCard : kardex.DocNum}</td>
                                        <td className="text-left">{kardex.ItemCode + '-' + kardex.ItemName}</td>
                                        <td className="text-left">{moment(kardex.TaxDate).utc().format('MM/DD/YYYY')}</td>
                                        <td className="text-right">{Number(kardex.InQty).toFixed(2)}</td>
                                        <td className="text-right">{Number(kardex.OutQty).toFixed(2)}</td>
                                        {/* <td className="text-right">{Number(kardex.Exist).toFixed(2)}</td> */}
                                    </tr>
                                );
                            })}
                            <br />

                            {/* <tr style={{ borderTop: "solid 1px" }}>
                                                            <td colspan="4" className="text-left">{DocsToPrint[0].ListKardex.length}</td>
                                                            <td className="text-right"><strong>Existencia: </strong></td>
                                                            <td className="text-right"><strong>{Number(DocsToPrint[0].ListKardex[0].OnHand).toFixed(2)}</strong></td>
                                                        </tr> */}
                        </tbody>
                    </table>
                </div>
                {/* <div className='row mt-4'>
                    <div className='col-7'></div>
                    <div className='col-5'>
                        <table>
                            <tbody style={{ borderTop: "solid 1px" }}>
                                <tr>
                                    <td className='text-right p-2' style={{ background: "#ddd" }}><strong>GRAN TOTAL: </strong></td>
                                    <td className='text-right p-2 mr-2' style={{ background: "#ddd" }}><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(Sales && Sales.BigTotal ? Sales.BigTotal : 0)}</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div> */}

                <div className='row mt-5' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2">ORDENES</th>
                            </tr>
                        </thead>
                    </table>

                    <table className='mt-2'>
                        <thead>
                            <tr>
                                <th className="text-left ml-5">No. de documento</th>
                                <th className="text-left">Fecha</th>
                                <th className="text-left">Código cliente</th>
                                <th className="text-left">Nombre del cliente</th>
                                <th className="text-center">Total</th>

                            </tr>
                        </thead>
                        <tbody>
                            {!!Orders && Orders.map((element, index) => {
                                return (
                                    <tr key={'returnReport' + index}>
                                        <td className="text-left">{element.DocNum || ''}</td>
                                        <td className="text-left">{moment(element.DocDate || '').utc().format('MM/DD/YYYY')}</td>
                                        <td className="text-left">{element.CardCode || ''}</td>
                                        <td className="text-left">{element.CardName || ''}</td>
                                        <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(element.DocTotal ?? 0)}</td>
                                    </tr>

                                )
                            })
                            }
                        </tbody>
                    </table>
                </div>

                <div className='row mt-5' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2">FACTURA</th>
                            </tr>
                        </thead>
                    </table>

                    <table className='mt-2'>
                        <thead>
                            <tr>
                                <th className="text-left ml-5">No. de documento</th>
                                <th className="text-left">Fecha</th>
                                <th className="text-left">Código cliente</th>
                                <th className="text-left">Nombre del cliente</th>
                                <th className="text-center">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!!Invoices && Invoices.map((element, index) => {
                                return (
                                    <tr key={'returnReport' + index}>
                                        <td className="text-left">{element.DocNum || ''}</td>
                                        <td className="text-left">{moment(element.DocDate || '').utc().format('MM/DD/YYYY')}</td>
                                        <td className="text-left">{element.CardCode || ''}</td>
                                        <td className="text-left">{element.CardName || ''}</td>
                                        <td className="text-right">{CURRENCY + ' ' + FORMAT_NUMBER.new(element.DocTotal ?? 0)}</td>
                                    </tr>

                                )
                            })
                            }
                        </tbody>
                    </table>
                </div>

                <br />
                <br />
                <br />
                <div className='row mt-2' style={{ paddingRight: "15px" }}>
                    <div className='col-12'>
                        <br />
                        <table>
                            <tbody>
                                <tr>
                                    <td className="text-center">Atentamente</td>
                                </tr>
                            </tbody>
                        </table>
                        <br /><br /><br />
                        <table>
                            <tbody>
                                <tr>
                                    <td className="text-center">______________________________</td>
                                    <td className="text-left"></td>
                                    <td className="text-center">______________________________</td>
                                </tr>
                                <tr>
                                    <td className="text-center">Gerente de Sucursal</td>
                                    <td></td>
                                    <td className="text-center">Chofer</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div >
        )

    }
}

export default DetailsCutInventory